// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackMakeWishListPrivateParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackMakeWishListPrivate";

const useTrackMakeWishListPrivate = (
    parameters: TrackMakeWishListPrivateParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.makeWishListPrivate, parameters, options);
};

export default useTrackMakeWishListPrivate;
